<!-- One projection slot, rendered in whichever branch applies. -->
<ng-template #content><ng-content /></ng-template>

@if (entry(); as e) {
  <span class="term">
    <button
      type="button"
      class="term__trigger"
      [class.term__trigger--first]="first()"
      [class.term__trigger--later]="!first()"
      [attr.aria-expanded]="open()"
      [attr.aria-controls]="popId"
      [attr.data-testid]="'term-' + key()"
      (click)="toggle()"
      (focus)="show()"
    >
      <ng-container [ngTemplateOutlet]="content" />
      @if (first()) {
        <span class="term__mark" aria-hidden="true" data-testid="term-mark">?</span>
      }
    </button>

    @if (open()) {
      <div class="term__pop" role="dialog" [id]="popId" [attr.aria-label]="e.term">
        <p class="term__title">{{ e.term }}</p>
        <p class="term__section">What it means</p>
        <p class="term__text">{{ e.meaning }}</p>
        <p class="term__section">What it means for you</p>
        <p class="term__text">{{ e.forYou }}</p>
        <p class="term__rule">Rule: {{ e.rule }} · glossary entry {{ e.version }}</p>

        @switch (case().state) {
          @case ('no-detail') {
            <div class="term__case" data-testid="term-in-this-case">
              <p class="term__section">In this case</p>
              <p class="term__text">The record holds no detail of how this was applied here.</p>
              <button type="button" class="term__flag" (click)="flag()">Flag this</button>
            </div>
          }
          @case ('blocks') {
            @if (case(); as c) {
              @if (c.state === 'blocks') {
                <div class="term__case" data-testid="term-in-this-case">
                  <p class="term__section">In this case</p>
                  @for (block of c.blocks; track $index) {
                    <app-basis-view class="term__block" [basis]="block" />
                  }
                  @if (run(); as r) {
                    <p class="term__rule">
                      Under rulebook {{ r.rulebook_version || 'not recorded' }} · prompt
                      {{ r.prompt_version || 'not recorded' }} · run of
                      {{ r.as_at | date: 'd MMM y, HH:mm' }}
                    </p>
                  }
                  <button type="button" class="term__flag" (click)="flag()">Flag this</button>
                </div>
              }
            }
          }
        }
      </div>
    }
  </span>
} @else {
  <ng-container [ngTemplateOutlet]="content" />
}
